export const IS_OPEN_CONTEXT_MENU_CLASS = '__context-is-open';
export const IS_MASTER_VIEW_CELL_CLASS = '__master-view-cell';
